import { useQuery } from '@apollo/client';

import {
  GET_RD_TAX_CREDIT_CONTRIBUTOR,
  GetRdTaxCreditContributorQuery,
  GetRdTaxCreditContributorQueryVariables,
} from '@neo.tax/shared';

export type RdTaxCreditContributor = GetRdTaxCreditContributorQuery['getRdTaxCreditContributor'];

export function useRdTaxCreditContributor(
  rdTaxCreditContributorId: string,
  options?: undefined,
):
  | {
      rdTaxCreditContributor: null;
      loading: true;
    }
  | {
      rdTaxCreditContributor: RdTaxCreditContributor;
      loading: false;
    };

export function useRdTaxCreditContributor(
  rdTaxCreditContributorId: string,
  options: { skip: boolean },
):
  | {
      rdTaxCreditContributor: null;
      loading: true;
    }
  | {
      rdTaxCreditContributor: RdTaxCreditContributor | null;
      loading: false;
    };

export function useRdTaxCreditContributor(
  rdTaxCreditContributorId: string,
  options?: { skip: boolean },
):
  | {
      rdTaxCreditContributor: null;
      loading: true;
    }
  | {
      rdTaxCreditContributor: RdTaxCreditContributor | null;
      loading: false;
    } {
  const { skip } = {
    skip: false,
    ...options,
  };

  const { data, error, loading } = useQuery<GetRdTaxCreditContributorQuery, GetRdTaxCreditContributorQueryVariables>(
    GET_RD_TAX_CREDIT_CONTRIBUTOR,
    {
      variables: { rdTaxCreditContributorId },
      skip,
    },
  );

  if (loading) {
    return { rdTaxCreditContributor: null, loading: true };
  }
  if (error) {
    throw error;
  }

  return {
    rdTaxCreditContributor: data?.getRdTaxCreditContributor ?? null,
    loading,
  };
}
